import { useEffect } from 'react';
import { RouterMetrics } from '../router/RouterMetrics';

/**
 * Log when our old routes render so we can see when we remove traffic from them
 * taken from https://git.hubteam.com/HubSpot/CRM/blob/361ff034a914021971131517009291731bc691a0/crm-records-ui/static/js/router/Router.js#L117
 */
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const OldRecordRouteLogger = ({
  type,
  children
}) => {
  useEffect(() => {
    RouterMetrics.counter(`old-route-${type}`).increment();
  }, [type]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default OldRecordRouteLogger;